import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { Ng2TableModule } from '../shared/components/ng-table/ng-table-module';
import { CustomerPageModule } from './customer-page/customer-page.module';

import { CustomersPageComponent } from './customers-page/customers-page.component';
import { ConfirmBlockReasonComponent } from './customers-page/confirm-block-reason/confirm-block-reason.component';
import { RequestsPageComponent } from './requests-page/requests-page.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';

@NgModule({
  declarations: [
    CustomersPageComponent,
    ConfirmBlockReasonComponent,
    RequestsPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
    NgSelectModule,
    Ng2TableModule,
    CustomerPageModule,
    SharedComponentsModule
  ],
  exports: [
    CustomersPageComponent
  ]
})
export class PagesModule { }
